import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Primary donate CTA — muted flag red with a subtle idle pulse glow
 * (disabled automatically under prefers-reduced-motion via theme.css).
 *
 * Props:
 *   to       — destination (default '/donate')
 *   children — label (default 'Donate')
 *   pulse    — enable the idle glow (default true; set false in dense UIs)
 *   size     — 'md' | 'lg'
 *   className — extra classes
 */
export const DonateButton = ({
  to = '/donate',
  children = 'Donate',
  pulse = true,
  size = 'md',
  className = '',
}) => {
  const sizing =
    size === 'lg'
      ? 'px-8 py-4 text-base'
      : 'px-6 py-3 text-sm';

  return (
    <Link
      to={to}
      className={`inline-flex items-center justify-center gap-2 rounded-btn bg-flag_red hover:bg-flag_red_deep text-white font-body font-bold uppercase tracking-label transition-colors duration-200 ${sizing} ${pulse ? 'oli-pulse' : ''} ${className}`}
    >
      {children}
    </Link>
  );
};

/**
 * Secondary CTA — aged-gold outline, pairs with DonateButton in hero rows.
 */
export const GoldOutlineButton = ({ to, children, size = 'md', className = '' }) => {
  const sizing =
    size === 'lg'
      ? 'px-8 py-4 text-base'
      : 'px-6 py-3 text-sm';

  const external = typeof to === 'string' && to.startsWith('http');
  const classes = `inline-flex items-center justify-center gap-2 rounded-btn border-2 border-gold text-gold_soft hover:bg-gold hover:text-forest_deep font-body font-bold uppercase tracking-label transition-colors duration-200 ${sizing} ${className}`;

  if (external) {
    return (
      <a href={to} target="_blank" rel="noopener noreferrer" className={classes}>
        {children}
      </a>
    );
  }
  return (
    <Link to={to} className={classes}>
      {children}
    </Link>
  );
};

export default DonateButton;
